import React from "react";

const Hero = () => {
  return (
    <section className="hero is-light">
      <div className="hero-body">
        <div className="container has-text-centered">
          <h1 className="title is-1 has-text-primary">artus</h1>
          <h2 className="subtitle">A place to share your knowledge.</h2>
        </div>
      </div>
    </section>
  );
};

export default Hero;
